export default "__VITE_ASSET__CJltkgX3__"